// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"38e972f9","285":"d2c553cd","307":"90e06501","453":"874d65d5","811":"695a8808"}[chunkId] + ".chunk.js";
};